/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestTheGraphStaking extends Contract<ITestTheGraphStaking> {
  delegationTaxPercentage: Call<() => BigNumber, ITestTheGraphStaking>
  'delegationTaxPercentage()': Call<() => BigNumber, ITestTheGraphStaking>
  getDelegation: Call<(_indexer: AddressLike, _delegator: AddressLike) => { shares_: BigNumber, tokensLocked_: BigNumber, tokensLockedUntil_: BigNumber }, ITestTheGraphStaking>
  'getDelegation(address,address)': Call<(_indexer: AddressLike, _delegator: AddressLike) => { shares_: BigNumber, tokensLocked_: BigNumber, tokensLockedUntil_: BigNumber }, ITestTheGraphStaking>
}

let ITestTheGraphStakingBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestTheGraphStakingBytecode = '0x';
}

// prettier-ignore
export const ITestTheGraphStaking = contract<ITestTheGraphStaking>(ITestTheGraphStakingBytecode)`
  function delegationTaxPercentage() view returns (uint32 taxPercentage_)
  function getDelegation(address _indexer, address _delegator) view returns (uint256 shares_, uint256 tokensLocked_, uint256 tokensLockedUntil_)
`;